export const isValidHttpOrHttpsUrl = (url?: string | null): boolean => {
  /**
   * Checks if the given URL is a valid HTTP URL.
   *
   * @param {string | null} url - The URL to validate.
   * @returns {boolean} - Returns true if the URL is valid, otherwise false.
   */
  try {
    new URL(url ?? "");

    return true;
  } catch {
    return false;
  }
};
